var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccupiedDoorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1880_6746",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1880_6746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5788 13.8473V1H4.13875V13.8549H3V14.2956H13.7328V13.8447H12.5788V13.8473ZM7.69767 8.95343H7.06843C7.00983 9.16742 6.81622 9.32792 6.58185 9.32792C6.30162 9.32792 6.07743 9.10119 6.07743 8.8235C6.07743 8.54582 6.30416 8.31909 6.58185 8.31909C6.81622 8.31909 7.00983 8.47704 7.06843 8.69358H7.69767C7.77155 8.69358 7.83014 8.75217 7.83014 8.82605C7.83014 8.89993 7.77155 8.95852 7.69767 8.95852V8.95343ZM11.6183 13.832H11.1802V2.3986H5.56283V13.8269H5.10682V1.94004H11.6209V13.832H11.6183Z",
    fill: "#ED705B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58222 9.01418C6.60895 9.01418 6.63062 8.9275 6.63062 8.82057C6.63062 8.71364 6.60895 8.62695 6.58222 8.62695C6.55548 8.62695 6.53381 8.71364 6.53381 8.82057C6.53381 8.9275 6.55548 9.01418 6.58222 9.01418Z",
    fill: "#62BA60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupiedDoorIcon);
export default __webpack_public_path__ + "static/media/occupied-door-icon.7dc3f3ddf8f84d8f4781b8d4b96f05f5.svg";
export { ForwardRef as ReactComponent };